import { RECORD_POINTS } from '../constants';

function CareSection() {
  return (
    <section id="structure" className="bg-steel">
      <div className="mx-auto max-w-6xl px-6 py-20">
        <div className="max-w-3xl">
          <p className="text-xs font-black uppercase text-teal">
            Structure
          </p>
          <h2 className="mt-3 text-4xl font-black tracking-tight text-ink sm:text-5xl">
            Key terms from the incorporation document.
          </h2>
          <p className="mt-5 leading-8 text-muted">
            The PDF is a legal filing, so the web page avoids invented product
            claims and presents the facts in a polished corporate layout.
          </p>
        </div>

        <div className="mt-12 grid gap-5 lg:grid-cols-3">
          {RECORD_POINTS.map((point, index) => (
            <article
              key={point.title}
              className="flex h-full flex-col border border-line bg-white p-7 transition hover:-translate-y-1 hover:shadow-soft"
            >
              <span className="text-sm font-black text-cyan">0{index + 1}</span>
              <p className="mt-8 text-[11px] font-black uppercase text-teal">
                {point.eyebrow}
              </p>
              <h3 className="mt-2 text-2xl font-black text-ink">{point.title}</h3>
              <p className="mt-4 leading-7 text-muted">{point.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CareSection;
